exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditorPane___-yRyn {\n  position: relative;\n  display: block;\n  background-color: var(--color-background);\n  color: var(--color-text);\n  font-family: var(--font-family-sans);\n}\n\n.EditorPane___-yRyn, .EditorPane___-yRyn * {\n  box-sizing: border-box;\n  -webkit-font-smoothing: var(--font-smoothing);\n}\n\n.EditorToolbar___lVD8R {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.5rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.EditorInfo___2ZoyD {\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.VRule___1mDQE {\n  height: 20px;\n  width: 1px;\n  flex: 0 0 1px;\n  margin: 0 0.5rem;\n  background-color: var(--color-border);\n}\n\n.WideButton___2aIsB {\n  flex: 1 0 auto;\n  display: flex;\n}\n", ""]);

// exports
exports.locals = {
	"EditorPane": "EditorPane___-yRyn",
	"EditorToolbar": "EditorToolbar___lVD8R",
	"EditorInfo": "EditorInfo___2ZoyD",
	"VRule": "VRule___1mDQE",
	"WideButton": "WideButton___2aIsB"
};